import { action, makeAutoObservable } from 'mobx';
import { Facebook, Instagram } from '@gamiphy/gamix-modules/social';

class SocialAuthStore {
  constructor() {
    makeAutoObservable(this);
  }

  @action
  async connectToFacebook(): Promise<void> {
    await Facebook.initialize();
    Facebook.authorize();
  }

  @action connectToInstagram(): void {
    Instagram.authorize();
  }
}

const SocialStoreInstance = new SocialAuthStore();

export default SocialStoreInstance;
